import { useEffect } from "react";
import api from "features/api";
import { useAppDispatch } from "features/store";

const MIN_INTERVAL_MS = 60_000;

/**
 * Access is decided per request on the server; reloading /me when the tab comes
 * back keeps menus and buttons in step with a changed group or tier.
 */
export function useProfileRefreshOnFocus(enabled: boolean): void {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!enabled) return;
    let last = Date.now();
    const refresh = () => {
      if (document.visibilityState === "hidden") return;
      const now = Date.now();
      if (now - last < MIN_INTERVAL_MS) return;
      last = now;
      dispatch(api.util.invalidateTags(["Auth"]));
    };
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [enabled, dispatch]);
}

export default useProfileRefreshOnFocus;
